import * as Sentry from "@sentry/react";
import {useEffect} from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const dsn = process.env.REACT_APP_SENTRY_DSN;
const environment = process.env.REACT_APP_APP_ENV || "development";
const release = process.env.REACT_APP_SENTRY_RELEASE;

/**
 * Sentry only runs in production. In development the SDK is never initialised, so
 * no events/replays are sent and there is zero runtime overhead locally.
 */
export const isSentryEnabled = environment === "production" && Boolean(dsn);

export function initSentry() {
  if (!isSentryEnabled) {
    return;
  }

  Sentry.init({
    dsn,
    environment,
    release,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance monitoring: sample 10% of transactions.
    tracesSampleRate: 0.1,
    // Session Replay: 10% of all sessions, and 100% of sessions with an error.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
